import { useContext } from 'react'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

export default function useGrowthOfferTile(eligible = true) {
  const page = useContext(AnalyticsPageContext)
  const canActivate = eligible && page === AnalyticsPage.homepage
  const { variation } = useExperiment(ChertoExperiments.croHomePageOfferTiles, { canActivate })
  return canActivate && variation === 'variant'
}
